import { useState } from "react";
import { SignInScreenControlled } from "../bento-controlled/forms/layouts/SignInScreen.mjs";
import { jsx } from "react/jsx-runtime";
const XPAuthSignIn = ({
  //type,
  handleOAuthWithPress,
  handleEmailWithPress,
  status,
  socialLogos
}) => {
  const [emailAddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  return /* @__PURE__ */jsx(SignInScreenControlled, {
    signInTools: {
      basicAuthProvider: {
        handler: () => handleEmailWithPress(emailAddress, password),
        setEmail: setEmailAddress,
        setPassword,
        status
      },
      socialProviders: [{
        handler: () => handleOAuthWithPress("oauth_apple"),
        logoSrc: socialLogos?.apple,
        providerName: "Apple"
      }, {
        handler: () => handleOAuthWithPress("oauth_google"),
        logoSrc: socialLogos?.google,
        providerName: "Google"
      }, {
        handler: () => handleOAuthWithPress("oauth_microsoft"),
        logoSrc: socialLogos?.microsoft,
        providerName: "Microsoft"
      }]
    }
  });
};
export { XPAuthSignIn };
//# sourceMappingURL=XPAuthSignIn.mjs.map
